import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/style/common.css'

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

import ElIcons from './components/ElIcons'
import ElButtons from './components/ElButtons'

import 'vant/lib/index.css';
import { Button, RadioGroup, Radio, Toast, Col, Row, Checkbox, CheckboxGroup, List, Search, Sticky  } from 'vant';

global.HOST = "/web";
// global.HOST_a = "/api";

const app = createApp(App);
app.use(Button);
app.use(Radio);
app.use(RadioGroup);
app.use(Toast);
app.use(Col);
app.use(Row);
app.use(Checkbox);
app.use(CheckboxGroup);
app.use(List);
app.use(Search);
app.use(Sticky);

app.use(ElementPlus)
app.component('ElIcons', ElIcons)
app.component('ElButtons', ElButtons)

app.use(store).use(router).mount('#app')
